import styled from 'styled-components';

export const QuoteCard = styled.div`
  min-height: 220px;
`;

export const InsuranceLogo = styled.img`
  width: 80px;
  margin-bottom: 8px;
`;

export const LoadingContainer = styled.div`
  min-height: 60vh;
  background: #fff;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StateIcon = styled.i`
  font-size: 100px;
`;
